export enum NotifierType {
    SUCCESS = 'success',
    INFO = 'info',
    WARNING = 'warning',
    ERROR = 'error',
}

export enum NotifierMessages {
    PLEASE_FILL_ALL_FIELDS = 'Please fill all fields.',
}

export enum ResponseErrorMessages {
    SOMETHING_WENT_WRONG = 'Something went wrong. Please try again later.',
}

export enum ResponseSuccessMessages {
    CONTACT_US_SUCCESS_MESSAGE = 'Your request has been submitted successfully! We will contact you soon!',
}
